.SearchPageHeader {
  .phone &,
  .tablet & {
    padding: 0 16px;
  }

  h1 {
    margin: 2rem 0;
    font: var(--font-heading-sm-bold);
    color: #9d9da9;

    b {
      &::first-letter {
        font: var(--font-heading-sm-bold);
        text-transform: uppercase;
      }

      display: inline-block;
      color: var(--primitives-colors-neutral-0);
    }
  }
}
